export interface IMessageCapability {
  destination: string;
  height: number;
  width: number;
  unit: string;
  availableLanguages: string[];
}
